




































import {Component, Vue, Watch} from "vue-property-decorator";
import {User} from "@/models/user";
import formRules from "@/helpers/formRules";

@Component
export default class ResetPassword extends Vue {
  resetPasswordFormValid = false;
  password = "";
  confirmPwd = "";
  myRules = {
    password: formRules.passwordRules,
    confirmPwd: formRules.confirmPasswordRules
  };

  mounted() {
    //TODO: check token is valid
  }

  pwdMatchError() {
    if (this.password) {
      return this.password === this.confirmPwd
        ? ""
        : this.$t("formRules.pwdMatchError");
    }
  }

  handleResetPassword(type: string) {
    this.$store
      .dispatch("session/resetPassword", {
        password: this.password,
        type: type,
        token: this.$route.query.token
      })
      .then(() => {
        this.$router.push({name: "home"});
      })
      .catch(error => {
        this.$store.dispatch("app/setSnackbarMessage", {
          message: "Something was wrong, retry later",
          color: "red"
        });
      });
  }
}
